module.exports = __webpack_public_path__ + "static/media/omega.3ad5bff7.svg";